<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dAeFUh/tc-custom/9780795346934.jpg?1726871296824" alt="This image is the cover for the book Wright Stuff"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wright Stuff
      </h1>
      <p class="bookDescription body article font2">
        <b>The former CEO of NBC “reflects on his years at the pinnacle of network television, and also on the Wrights’ work as co-founders of Autism Speaks”</b> <b>(<i>Palm Beach Daily News</i>).</b><br/>  <br/> Named president and CEO of NBC at the age of 43, he faced a two-headed dragon: on one hand, distrust from the network people deeply skeptical of the “suit” from GE, their new corporate parent; and on the other, fiscal oversight demands from a cautious, conservative institution reluctant to invest heavily in a media business they didn’t understand. For the next 20 years, he managed to navigate the fine line between the two and in the process completely reinvent—and save—the network.<br/>  <br/> His name is Bob Wright. Under his leadership, a traditional network, struggling to survive a changing landscape, was transformed into a $45 billion cable and internet giant.<br/>  <br/> What does someone like that do when he retires? If he’s Bob Wright, he starts all over again. At almost the exact same time as Bob’s NBC reign was winding down, his grandson Christian was diagnosed with autism, a condition then poorly understood. Baffled by a lack of medical knowledge and community support, Bob and his wife Suzanne founded Autism Speaks, which in short order became the leading advocacy and research funding organization for this mysterious condition that so devastates families.<br/>  <br/> As the two story lines unfold in <i>The Wright Stuff</i>, readers will gradually see that both endeavors—revitalizing NBC and building Autism Speaks—reflect the same key management tenets that apply to any organization facing disruptive change.<br/>  <br/><i>A portion of the proceeds from this book will be donated to advance autism research.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Wright, Diane Mermigas
      </h2>
      
      <p class="authorDescription body article">Bob Wright served as Vice Chairman of General Electric until 2008 and Chairman and Chief Executive Officer of NBC Universal until 2007. From his appointment as president and CEO of NBC in September 1986 he had one of the longest and most successful tenures of the world's leading media and entertainment company chief executives.  Throughout his 40-year career at GE, Bob had a strong involvement in community service and philanthropy for which he received numerous awards and accolades. Today, he is Senior Advisor of Lee Equity Partners and Chairman and CEO of the Palm Beach Civic Association. Autism Speaks, founded by Bob and his wife, Suzanne, has led the way for more than a decade in global autism research, advocacy, and support services. He serves on the boards of Polo Ralph Lauren Corporation and AMC Networks Inc., and is a Trustee of the New York Presbyterian Hospital.   He was formerly on the Board of Trustees of the Rand Corporation and a Director of the EMI Group Global Ltd. board. He is a graduate of the College of the Holy Cross and of the Law School of University of Virginia. The Wrights have three children and six grandchildren.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4654ae3e